export default "__VITE_ASSET__Bibq2Qa5__"